module.exports = {
    alerts: {
        deleteFile: "Czy na pewno chcesz usunąć ten plik?",
        error: "Błąd",
        success: "Pomyślnie",
        warning: "Uwaga",
        unknownError: "Nieznany błąd",
        fileNotFound: "Plik nie został znaleziony!",
        fileNotUploaded: "Plik nie został przesłany!",
        fileNotDeleted: "Plik nie został usunięty!",
        newAccessRequestTitle: "Nowe zapytanie o dostęp!",
        newAccessRequestBody: "Dystrybutor chce uzyskać dostęp do klienta"
    },
    asks: {
        warning: "Uwaga",
        confirmCuttingTitle: "Wysłać do cięcia?",
        confirmCuttingText: "Zamówienie zostanie przeniesione do sekcji \"Nowe\", a wszyscy monterzy otrzymają powiadomienie.",
        confirmCuttingDoneTitle: "Zakończyć cięcie?",
        confirmCuttingDoneText: "Zamówienie otrzyma status \"Zakończone\".",
        delete_status: "Czy na pewno chcesz usunąć status użytkownika?",
        confirmTakeOrder: "Czy na pewno chcesz przyjąć to zamówienie do realizacji?",
        confirmWasCutReminder: "Zmieniasz status na 'Zakończone', ale nie kliknąłeś przycisku 'Wzór pocięty'. Szablon nie zostanie oznaczony jako pocięty. Kontynuować mimo to?",
        deleteUser: "Czy na pewno chcesz usunąć użytkownika?",
        confirmClone: "Czy na pewno chcesz sklonować to zamówienie?",
        delete_file: "Czy na pewno chcesz usunąć plik?",
        deleteCut: "Na pewno usunąć wzór?",
        deleteNoteTitle: "Usunąć notatkę?",
        requestNoteDeletionTitle: "Wysłać prośbę o usunięcie?",
        requestNoteDeletionText: "Notatka zostanie usunięta po zatwierdzeniu przez administratora."
    },
    buttons: {
        clearFilter: "Wyczyść",
        selectPatterns:"Wybierz wzory z bazy danych",
        reply: "Odpowiedz",
        reaction: "Reakcja",
        sendAccessRequest: "Wyślij prośbę o dostęp",
        reloadPage: "Odśwież stronę",
        recordAudioNote: "Nagraj wiadomość głosową",
        stopRecording: "Zatrzymaj nagrywanie",
        stop: "Zatrzymywać się",
        sendToCutting: "Wysłać do cięcia",
        cuttingDone: "Wykrój został pocięty (Zakończ)",
        imHere: "Jestem tutaj!",
        clearStatus: "Usuń status",
        addStatus: "Dodaj status",
        add: "Dodaj",
        addClient: "Dodaj klienta",
        addNote: "Dodaj notatkę",
        acknowledged: "Zapoznałem się",
        addOrder: "Dodaj zamówienie",
        addUser: "Dodaj użytkownika",
        apply: "Zastosuj",
        cancel: "Anuluj",
        confirm: "Potwierdź",
        delete: "Usuń",
        deleteClient: "Usuń klienta",
        deleteOrder: "Usuń zamówienie",
        edit: "Edytuj",
        editOrder: "Edytuj zamówienie",
        logoutBtn: "Wyloguj się",
        show: "Pokaż",
        hide: "Ukrywać",
        send: "Wyślij",
        save: "Zapisz",
        subscribeUser: "Subskrybuj powiadomienia",
        takeToWork: "Przyjmij do realizacji",
        unsubcribeUser: "Anuluj subskrypcję powiadomień",
        update: "Aktualizuj",
        clone: "Klonuj",
        downloadAllCuts: 'Pobierz wszystko',
        loading: "Ładowanie",
    },
    days: {
        friday: "Piątek",
        monday: "Pon",
        saturday: "Sob",
        sunday: "Nie",
        thursday: "Czw",
        tuesday: "Wto",
        wednesday: "Śro"
    },
    errors: {
        notificationNotSupported: "Twoja przeglądarka nie obsługuje powiadomień",
        serviceWorkerNotSupported: "Twoja przeglądarka nie obsługuje Service Workera",
        pushManagerNotSupported: "Twoja przeglądarka nie obsługuje powiadomień push",
        notificationPermissionRequired: "Wymagana jest zgoda na wyświetlanie powiadomień",
        serviceWorkerTimeout: "Przekroczono limit czasu Service Workera",
        subscriptionFailed: "Nie udało się zasubskrybować",
        unsubscribeFailed: "Nie udało się anulować subskrypcji",
        notificationRequestPermission: "Brak zgody na powiadomienia",
        subcriptionToServer: "Błąd podczas subskrypcji powiadomień:",
        user_already_exists: "Użytkownik już istnieje",
        invalid_request: "Nieprawidłowe żądanie",
        user_not_found: "Nie znaleziono użytkownika",
        user_updated: "Użytkownik został zaktualizowany",
        wrong_password: "Nieprawidłowe hasło",
        invalid_data: "Nieprawidłowe dane",
        access_denied: "Nie masz dostępu do tej funkcji",
        invalid_token: "Nieprawidłowy token",
        not_found: "Nie znaleziono żadnych danych",
        create_failed: "Błąd tworzenia",
        update_failed: "Błąd aktualizacji",
        delete_failed: "Błąd usuwania",
        unknown_error: "Nieznany błąd",
        order_delete_failed: "Nie udało się usunąć zamówienia!"
    },
    headings: {
        draftsmenStats: "Statystyki monterów",
        anomalousSessions: "Sesje anomalne (≥ 8 godz.)",
        completedOrders: "Zrealizowane zamówienia",
        clientOrder: "Zamówienie klienta",
        newOrders: "Nowe zamówienia",
        orderData: "Dane zamówienia",
        carData: "Samochód",
        statusSection: "Status i dostępność szablonów",
        actors: "Klient i menedżer",
        ordersForPeriod: "Zamówienia z okresu",
        ordersInProgress: "Zamówienia w realizacji"
    },
    labels: {
        replyPhoto: "Zdjęcie",
        replyVideo: "Wideo",
        replyVoice: "Wiadomość głosowa",
        replyMedia: "Multimedia",
        replyUser: "Użytkownik",
        replyTo: "Odpowiedź do",
        editMessage: "Edycja wiadomości",
        clientOwner: "Klient Dystrybutor",
        clientNotes: "Notatki klienta",
        clientNote: "Notatka klienta",
        problemPattern: "Problematyczny wzór",
        problemPackaging: "Problem z opakowaniem",
        wasCut: "Szablon pocięty",
        hasNoPatterns: "Brak szablonów",
        patternRequestSent: "Wysłano prośbę o szablony",
        noPatternsSelectStatus: "Wybierz status braku szablonów",
        noPatternsNoneInAny: "Brak szablonów w żadnej z baz",
        noPatternsNoneInOurs: "Brak szablonów w naszych bazach",
        noPatternsPartial: "Szablony częściowo dostępne",
        noPatternsPartialBadge: "Częściowo",
        assemblyProgram: "Program montażu",
        assemblyProgramSelect: "Wybierz program montażu",
        assemblyProgramHint: "Można wybrać kilka. Programy z odcinków są pobierane automatycznie i zarządzane w odcinkach.",
        assemblyProgramLocked: "Ustawiono na odcinku — zmień w odcinkach",
        assembledIn: "Zmontowano w programie",
        filterNoPatternsPartial: "Szablony częściowo dostępne",
        filterNoPatternsLabel: "Dostępność szablonów",
        filterAssemblyProgramAll: "Program montażu: wszystkie",
        filterNoPatternsAllOrders: "Szablony: wszystkie zamówienia",
        filterNoPatternsAny: "Brak szablonów (wszystkie)",
        manualTitle: "Wprowadź nazwę ręcznie",
        unknown: "Nieznany",
        unknownModel: "Nie znam modelu/roku lub brak modelu",
        pattern: "Szablon",
        files: "Pliki",
        accessTo: "Dostęp do",
        created: "Utworzono",
        processed: "Przetworzono",
        waitingConfirmation: "Oczekuje na potwierdzenie",
        listened: "Wysłuchano",
        audioNotes: "Wiadomości głosowe",
        cutting: "Cięcie",
        statusName: "Nazwa statusu",
        statusColor: "Kolor statusu",
        statusRole: "Do jakiej roli służy status",
        setStatus: "Status",
        onlineUsers: "Kto jest w sieci",
        addAutomatically: "Zostanie dodane automatycznie",
        addCutToOrder: "Dodaj wzór do zamówienia",
        order_deleted: "Usuwanie zamówienia",
        toWorkPt1: "Zamówienie",
        toWorkPt2: "zostało przyjęte",
        carPhotos: "Zdjęcie samochodu",
        customPeriod: "Okres",
        editCut: "Edytuj wzór",
        filmLength: "Długość folii",
        filmWidth: "Szerokość folii",
        filmCutsForOrder: "Cięcia folii do zamówienia",
        isActiveUser: "Użytkownik jest aktywny",
        orderFiles: "Pliki do zamówienia",
        orders: "Zamówienia",
        orderViewedBy: "Zamówienie przegląda:",
        orderStatus: "Status zamówienia",
        orderFromDistributor: "Zamówienie od dystrybutora",
        phone: "Telefon",
        shortDescription: "Krótki opis",
        lastUpdate: "Ostatnia aktualizacja",
        totalFilmArea: "Całkowita powierzchnia folii",
        userGroup: "Grupa użytkownika",
        urgent: "Pilne!",
        changeHistory: "Historia zmian",
        badge: "Odznaka",
        translations: "Tłumaczenia",
        select_value: "Wybierz wartość"
    },
    log: {
        yes: "Tak",
        no: "Nie",
        subcriptionUnsubscribe: "Subskrypcja została anulowana.",
        orderUrgent: "Pilne zamówienie",
        orderNotUrgent: "Niepilne zamówienie",
        notePrefix: "Uwaga",
        noItems: "Brak",
        allCutsDeleted: "Usunięto wszystkie wykroje",
        fields: {
            title: "Nazwa",
            description: "Uwaga",
            status: "Status",
            isUrgent: "Terminowość",
            clientId: "Klient",
            managerId: "Menedżer",
            image: "Obrazy",
            file: "Pliki",
            cuts: "Fragmenty filmu do zamówienia",
            hasProblematicPattern: "Problem z szablonem",
            hasProblematicPackaging: "Problem z pakowaniem",
            wasCut: "Szablon pocięty",
            wasCutBadge: "Pocięte",
            hasNoPatterns: "Brak szablonów",
            noPatternsType: "Status braku szablonów",
            patternRequestSent: "Wysłano prośbę o szablony",
            assemblyPrograms: "Program montażu"
        }
    },
    units: {
        m: "m"
    },
    messages: {
        downloadingPatterns: "Przesyłanie wzorów na serwer...",
        selectModelOrCheckUnknown: "Proszę wybrać model i rok samochodu lub zaznaczyć pole „Nie znam modelu/roku”.",
        nothingFound: "Nic nie znaleziono",
        cutsSaving: "Zapisywanie wykrojów…",
        cutsSaved: "Wykroje zapisane",
        cutsSaveError: "Nie udało się zapisać wykrojów",
        anomalyExcluded: "Sesje ≥ 8 godz. nie są wliczane do czasu pracy",
        carChangedDeletePatterns: "Wybraliście inny model. Poprzednie szablony zostaną usunięte. Kontynuować?",
        accessRequestSent: "Zapytanie zostało wysłane! Proszę czekać na potwierdzenie.",
        requestFailed: "Błąd podczas wysyłania zapytania",
        accessGranted: "Dostęp udzielony",
        accessRejected: "Zapytanie odrzucone",
        noRequests: "Brak zapytań",
        noClientNotes: "Brak notatek",
        noteDeletionRequestSent: "Prośba o usunięcie wysłana do administratora",
        noteDeletionRequestPending: "Prośba o usunięcie tej notatki została już wysłana",
        noteDeletionApproved: "Notatka usunięta",
        noteDeletionRejected: "Prośba odrzucona",
        noNoteDeletionRequests: "Brak próśb o usunięcie notatek",
        noMicrophoneAccess: "Dostęp do mikrofonu jest zabroniony",
        audioRecordTooShort: "Nagranie jest zbyt krótkie, nic nie zostało pobrane.",
        orderCuttingDone: "Gotowe!",
        orderSentToCutting: "Wysłano!",
        statusUpdated: "Status zaktualizowany",
        statusCreated: "Status utworzony",
        noManagersOnline: "Brak menedżerów online",
        noDraftsmenOnline: "Brak projektantów online",
        fileDeleted: "Plik {name} został pomyślnie usunięty",
        isUrgent: "Zamówienie jest pilne",
        uploadedFiles: "Pliki przesłane",
        uploadedImages: "Obrazy przesłane",
        deleteClientMsg: "Czy na pewno chcesz usunąć klienta",
        successfullyDeleteClientMsg: "Klient został usunięty pomyślnie",
        errorDeleteClient: "Błąd podczas usuwania klienta",
        clientHasOrders: "Klient ma przypisane zamówienia, usunięcie niemożliwe!",
        cutDeleted: "Wzór został usunięty",
        confirmDeleteOrderPt1: "czy na pewno chcesz usunąć zamówienie",
        confirmDeleteOrderPt2: "Zostaną usunięte wszystkie powiązane dane",
        userDeleted: "Użytkownik został usunięty",
        onlyImageDownload: "Można pobrać tylko obraz!",
        fileTooLarge: "Rozmiar pliku przekracza dozwolony limit",
        invalidFileType: "Nieprawidłowy typ pliku",
        confirmImageDelete: "Czy na pewno chcesz usunąć obraz?",
        orderUpdated: "Zamówienie zostało zaktualizowane",
        orderCloned: "Zamówienie zostało pomyślnie sklonowane",
        noChanges: "Nie było zmian",
        noResults: "Nie znaleziono żadnych wyników. Spróbuj zmienić zapytanie.",
        firstSearchResults: "Wyświetlono pierwsze 50 wyników. Kontynuuj pisanie, aby uzyskać dokładniejsze wyniki...",
        selectNoPatternsStatus: "Proszę wybrać status braku szablonów."
    },
    modal: {
        chatErrorTitle: "Błąd czatu",
        chatErrorText: "Nie udało się wysłać wiadomości. Wygląda na to, że wystąpił błąd połączenia. Proszę ponownie załadować stronę.",
        editStatus: "Edytuj status",
        addStatus: "Dodaj status",
        addOrder: "Dodaj zamówienie",
        editOrder: "Edytuj zamówienie",
        inactivityTitle: "Jesteś jeszcze tutaj?",
        inactivityText: "Zauważyliśmy, że nie wykazałeś aktywności przez 15 minut.",
        inactivitySubtext: "Jeśli się oddaliłeś, proszę, ustaw odpowiedni status, aby Twoi koledzy byli na bieżąco.",
    },
    months: {
        april: "Kwi",
        august: "Sie",
        december: "Gru",
        february: "Lut",
        january: "Sty",
        july: "Lip",
        june: "Cze",
        march: "Mar",
        may: "Maj",
        november: "Lis",
        october: "Paź",
        september: "Wrz"
    },
    navbar: {
        adminPanel: "Panel administracyjny",
        allOrderList: "Lista wszystkich zamówień",
        mainPage: "Strona główna",
        myClients: "Moi klienci",
        draftsmenStats: "Statystyki monterów"
    },
    placeholders: {
        selectDraftsman: "Wyszukaj montera",
        search: "Szukaj...",
        selectBrand: "Wybierz markę",
        selectModel: "Wybierz model",
        selectYear: "Wybierz rok",
        recordingInProgress: "Nagrywanie w toku...",
        DraftsManName: "Imię projektanta",
        carBrandModel: "Marka i model samochodu",
        clientName: "Imię klienta",
        clientPhone: "Telefon klienta",
        clientStatus: "Status klienta",
        clientNote: "Np.: Zawsze bez kierunkowskazów",
        managerName: "Imię menedżera",
        orderDescription: "Opis zamówienia",
        searchClientByName: "Szukaj klienta po imieniu",
        searchUserByName: "Szukaj użytkownika po imieniu",
        selectClient: "Wybierz klienta",
        selectFiles: "Wybierz plik",
        selectManager: "Wybierz menedżera",
        userLogin: "Login użytkownika",
        userPassword: "Hasło użytkownika",
        writeMessage: "Napisz wiadomość..."
    },
    ranges: {
        last7: "Ostatnie 7 dni",
        thisMonth: "Bieżący miesiąc",
        lastMonth: "Ostatni miesiąc",
        thisYear: "W tym roku",
        allTime: "Za cały okres",
        today: "Dzisiaj",
        yesterday: "Wczoraj"
    },
    tableheadings: {
        completedOrders: "Wykonano",
        totalTime: "Czas pracy",
        reprocessedOrders: "Przeróbka",
        anomalies: "Anomalie",
        reprocessTime: "Czas przeróbki",
        averageTime: "Śr. czas",
        longestTime: "Najdłuższy czas",
        requests: "Zapytania dystrybutorów",
        noteDeletionRequests: "Usuwanie notatek",
        noteDeletionHistory: "Historia usuniętych notatek",
        badges: "Odznaki",
        actions: "Działania ze statusem",
        color: "Kolor",
        role: "Rola",
        statuses: "Lista statusów",
        draftsman: "Projektant",
        distributor: "Dystrybutor",
        added: "Dodano",
        client: "Klient",
        clients: "Klienci",
        closed: "Zamknięte",
        completed: "Zakończone",
        created: "Utworzono",
        date: "Data",
        edited: "Edytowano",
        history: "Historia",
        manager: "Menedżer",
        name: "Imię",
        note: "Notatka",
        notes: "Notatki",
        status: "Status",
        title: "Tytuł",
        type: "Typ",
        user: "Użytkownik",
        users: "Użytkownicy",
        all: "Wszyscy",
        preview: "Podgląd",
        table_actions: "Akcje"
    },
    titles: {
        printImage: "Wydrukuj obraz",
        attentionNotes: "Uwaga! Tutaj są notatki",
        mainNote: "Główna notatka"
    },
    statuses: {
        cutting: "Cięcie wzoru",
        active: "Nowe zamówienie",
        closed: "Zamknięte",
        done: "Zrealizowane",
        work: "W trakcie",
        pending: "Oczekuje",
        approved: "Zatwierdzono",
        rejected: "Odrzucono"
    },
    auth: {
        loginLabel: "Twój login",
        loginRequired: "Wpisz swój login",
        passwordLabel: "Hasło",
        passwordPlaceholder: "Wpisz swoje hasło",
        loginButton: "Zaloguj się",
        loginNote: "Informacje o logowaniu można uzyskać od administratora",
        registerTitle: "Rejestracja w systemie",
        yourLoginLabel: "Twój login",
        usernamePlaceholder: "Utwórz login",
        yourPasswordLabel: "Twoje hasło",
        passwordCreatePlaceholder: "Utwórz hasło",
        passwordConfirmLabel: "Potwierdź hasło",
        passwordConfirmPlaceholder: "Powtórz hasło",
        registerButton: "Zarejestruj się"
    },
    notifications: {

        order: "Zamówienie",
        draftsman: "Rysownik",
        client: "Klient",
        manager: "Menedżer",
        audioMessage: "Wiadomość głosowa",
        defaultTitle: "Wiadomość",
        testTitle: "Test powiadomień",
        testText: "Test wiadomości!!!",
        newOrder: "Nowe zamówienie",
        assignedToOrder: "Zostałeś przypisany do zamówienia",
        takenToWork: "Zamówienie przyjęte do realizacji",
        orderDone: "Zamówienie zrealizowane",
        chatMessage: "Nowa wiadomość na czacie",
        reminder: "Masz zamówienia, które nie zostały zamknięte. Zmień ich status"
    },
    operations: {
        create: "Utwórz",
        update: "Aktualizuj",
        delete: "Usuń",
        get: "Pobierz",
        getByType: "Pobierz według typu",
        getByDate: "Pobierz według daty",
        login: "Zaloguj",
        logout: "Wyloguj",
        upload: "Prześlij plik",
        get_order: "Pobierz dane zamówienia",
        edit_order: "Edytuj dane zamówienia",
        error: "Błąd systemu"
    },
    time: {
        hours_short: "godz.",
        minutes_short: "min",
        seconds_short: "sek.",
        minutes: "minut temu",
        minute: "1 minuta temu",
        hours: "godzin temu",
        hour: "1 godzina temu",
        days: "dni temu",
        day: "1 dzień temu",
        weeks: "tygodni temu",
        week: "1 tydzień temu",
        months: "miesięcy temu",
        month: "1 miesiąc temu"
    },
    logwords: {
        car: "Samochód",
        carBrand: "Marka samochodu",
        carModel: "Model samochodu",
        carYear: "Rok produkcji samochodu",
        user: "użytkownik",
        order: "zamówienie",
        client: "klient",
        current: "Obrazy, które już były",
        file: "plik",
        file_added: "Dodany plik",
        was: "Było:",
        became: "Stało się:",
        deleted: "Usunięto",
        added: "Dodano",
        existed: "Były zdjęcia"
    },
    common: {
        crud: {
            titles: {
                list: 'Lista {name}',
                create: 'Utwórz {name}',
                edit: 'Edytuj {name}',
                view: 'Podgląd {name}'
            }
        },

        created_success: '{name} został pomyślnie utworzony.',
        created_error: 'Błąd podczas tworzenia {name}.',

        updated_success: '{name} został pomyślnie zaktualizowany.',
        updated_error: 'Błąd podczas aktualizacji {name}.',

        confirm_delete: 'Czy na pewno chcesz usunąć {name}?',
        deleted_success: '{name} został pomyślnie usunięty.',
        deleted_error: 'Błąd podczas usuwania {name}.',

        load_error: 'Błąd podczas ładowania {name}.'
    },
    validation: {
        required: 'Pole {field} jest wymagane.',
        email: 'Wprowadź poprawny email.',
        min: 'Minimalna długość pola {field} to {min} znaków.',
        max: 'Maksymalna długość pola {field} to {max} znaków.',
        min_value: 'Wartość pola {field} nie może być mniejsza niż {min}.',
        max_value: 'Wartość pola {field} nie może być większa niż {max}.',
        confirmed: 'Potwierdzenie pola {field} nie pasuje.',
        numeric: 'Pole {field} może zawierać tylko cyfry.',
        string: 'Pole {field} musi być tekstem.',
        boolean: 'Pole {field} musi być true lub false.',
        array: 'Pole {field} musi być tablicą.',
        integer: 'Pole {field} musi być liczbą całkowitą.',
        date: 'Pole {field} musi być poprawną datą.',
        url: 'Pole {field} musi być prawidłowym URL.',
        unique: 'Pole {field} musi być unikalne.',
        exists: 'Wybrana wartość dla {field} jest nieprawidłowa.',
        digits: 'Pole {field} musi zawierać {digits} cyfr.',
        regex: 'Pole {field} ma nieprawidłowy format.',
        phone: 'Wprowadź poprawny numer telefonu.',
        same: 'Pola {field} i {other} muszą być takie same.',
        in: 'Nieprawidłowa wartość dla {field}.',
        not_in: 'Wartość pola {field} jest niedozwolona.',
        between: 'Pole {field} musi być między {min} a {max}.',
        file: 'Pole {field} musi być plikiem.',
        mimes: 'Plik w polu {field} musi być typu: {types}.',
        size: 'Rozmiar pliku w polu {field} nie może przekraczać {size} KB.'
    },
    table: {
        placeholders: {
            empty_heading: 'Dane nie zostały jeszcze dodane.',
            empty_description: 'Gdy tylko dane zostaną dodane, zostaną tutaj wyświetlone!'
        }
    },
    sso: {
        "redirecting_title": "Przekierowanie...",
        "redirecting_text": "Logowanie do Delivery CRM",
        "error_title": "Błąd",
        "error_text": "Nie udało się wygenerować linku do logowania. Spróbuj ponownie później."
    },
    patterns: {
        cutId: "ID szablonu:",
        meter: "Metr",
        "databaseTitle": "Baza szablonów",
        "searching": "Szukamy odpowiednich szablonów...",
        "openOnWebsite": "Otwórz \"{brand} {model}\" na stronie szablonów",
        "notFound": "Niestety, nie znaleziono szablonów dla tego modelu i rocznika.",
        "viewPatterns": "Zobacz szablony",
        "openOnSite": "Otwórz na stronie",
        "backToCars": "Powrót do listy samochodów",
        "addedToCuts": "Ten szablon został dodany do ścinków"
    }
};